import React, {Component} from 'react';
import { connect } from 'react-redux';
import { DISPATCH_ID, SERVICE_API, VIEW_NAME, config } from '../../libs/utils/Const';
import { NavBar, NotificationsModal, Session } from '../../components';
import { ApiClient } from '../../libs/apiClient/ApiClient';
import $ from 'jquery';
import '../../index.css';
import moment from 'moment';
let apiClient = ApiClient.getInstance();
class RegistroPedidosView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Codigo : '',
            RegistroPedidos : [],
            Tipo : 'W',
            order: [],
            csvData: [],
            checkboxDataTables: (new Map(): Map<string, boolean>),
            responseArray :[],
            orderBy:'ID',
            search:'',
            showPopup:false,
            fechaInicio: moment(new Date()).format('YYYY-MM-DD'),
            fechaFinal: moment(new Date()).format('YYYY-MM-DD'),
        };
        this.table = null;
    };

    async componentDidMount(){
        const {enableSpinner} = this.props;
        enableSpinner(true);
            this.cargarDatos();       
        enableSpinner(false);
    };

    async cargarDatos (){
        const { orderBy, search, fechaInicio, fechaFinal} = this.state;
        const {enableSpinner} = this.props;
        enableSpinner(true);
        let data = {
            orderBy,
            search,
            fechaInicio,
            fechaFinal
        }
       
        let apiResponse = await apiClient.getRegistroPedidos(data);
        this.setState({   
            RegistroPedidos: apiResponse.data.pedidos,
        });
        
        setTimeout(async () => {
            this.table = $('#tablaRegistroPedidos').DataTable({
                paging: false,
                info: false,
                searching: false,
        });
       
            enableSpinner(false);
        }, 300);
        
        
    };

   
    changeSearch = (event) => {        
        this.setState({
            search: event.nativeEvent.target.value,
        })
        
    };
    searchByDate = async response => {
        this.table.destroy();
        setTimeout(() => {
            this.cargarDatos()
        }, 150)
    }
    setShowPopup(value){
        this.setState({
            showPopup:value
        })
    }
    handleInputDateInicio = event =>{
        let fechaInicio = event.nativeEvent.target.value;
        this.setState({
            fechaInicio
        });
    }
    handleInputDateFinal = event =>{
        let fechaFinal = event.nativeEvent.target.value;
        this.setState({
            fechaFinal
        });
    }
    render() {
        const {history} = this.props;
       const { RegistroPedidos, search, showPopup, fechaFinal,fechaInicio } = this.state
        return (
            <div className="content-fluid" style={{marginTop: 66}}>
                <Session history={history} view={VIEW_NAME.AUTORIZA_VIEW}/>
              
                <NavBar/>
                
                <div className="container mb-4" style={{paddingTop: 60}}>
                    <div className="row">
                        <div className="col">
                            <div className="jumbotron" style={{paddingTop:'10px', paddingBottom:'10px'}}>
                                {/* <h2 className="display-6 text-center">{usuario === 167 || usuario === 208 || usuario === 206 ? 'Autorización de Transferencia Gratuita' : 'Autorización de Pedidos'}</h2> */}
                                <h2 className="display-6 text-center">Registro de Pedidos</h2>
                            </div>
                        </div>    
                    </div>
                </div>

                <div className="container col-md-10" >
                    <div className="row" style={{backgroundColor:'white'}}>
                        <p>Buscar:</p>
                        <div className="col-md-2 col-sm-10 popups-container">
                            {showPopup && <div className="popups" >Número único, Cliente, Total, Número de documento </div>}
                            <input
                                class="animated-input form-control btn-outline-secondary"
                                style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}       
                                type="text"
                                id="SearchInput"
                                value={search}
                                onMouseOver={() => this.setShowPopup(true)}
                                onMouseOut={() => this.setShowPopup(false)}
                                onChange={(event)=>this.changeSearch(event)}
                                onKeyDown={(event) => event.keyCode === 13 ? this.searchByDate() : ''}
                                placeholder="Número único, Cliente, Total, Número de documento"
                            />
                        </div>
                        
                        <div className="col-md-1 col-sm-10">
                            <button type="button" class="btn btn-primary float-right" style={{display:'block'}} data-toggle="modal" data-target=".estasSeguro" onClick={this.searchByDate}>Buscar</button>
                        </div>
                    </div>
                    <div className="row text-center mt-5">
                        <div className=" row col-md-4">
                            <h4 className="pr-2">Desde:</h4>
                            <input 
                                id="fechaInicio"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechauno" 
                                value = {fechaInicio}
                                onChange = {(event) => this.handleInputDateInicio(event)}/>
                        </div>
                        <div className="row col-md-4 pb-3">
                            <h4 className="pr-2">Hasta:</h4>
                            <input 
                                id="FechaFin"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechados" 
                                value = {fechaFinal}
                                onChange = {(event) => this.handleInputDateFinal(event)}/>
                        </div>
                    </div>
                    <br></br>

                    <div className="table-responsive" style={{marginBottom: 0, height: 'auto', maxHeight: 1110 , overflow: 'auto', fontSize:"13px", fontWeight:"bold",width: '100%'}}> 
                        <table id="tablaRegistroPedidos" className="table table-hover scrolltable" >
                            <thead >
                                <tr className="text-light" style={{cursor:'pointer'/*background: '#2d75bd', borderRadius: '0' */}} >
                                    <th className="text-center" scope="col">Número Único</th>
                                    <th className="text-center" scope="col">Cliente</th>
                                    <th className="text-center" scope="col">Nombre cliente</th>
                                    <th className="text-center" scope="col">Tipo de Identificación</th>
                                    <th className="text-center" scope="col">Numero Identificación</th>
                                    <th className="text-center" scope="col">Total</th>                                
                                    <th className="text-center" scope="col">Fecha de Contabilización</th>
                                    <th className="text-center" scope="col">Fecha de Creación</th>
                                    <th className="text-center" scope="col">Hora de Creación</th>
                                    <th className="text-center" scope="col">Numero de Documento</th>
                                    <th className="text-center" scope="col">Tipo de venta</th>
                                    <th className="text-center" scope="col">Tabla</th>
                                    <th className="text-center" scope="col">Estado del documento</th>
                                </tr>
                            </thead>
                            <tbody style={{overflowY:'auto',textOverflow: 'ellipsis',overflow:'hidden'}}>
                                {RegistroPedidos && RegistroPedidos.length>0 &&RegistroPedidos.map((pedido, index ) => {
                                        return(
                                            <tr key={index}>
                                                <td className="text-center">{pedido.PK_ID_PEDIDOS}</td>
                                                <td className="text-center">{pedido.CARDCODE}</td>
                                                <td className="text-center">{pedido.CARDNAME}</td>
                                                <td className="text-center">{pedido.SYP_BPTD_TEXT}</td>
                                                <td className="text-center">{pedido.FEDERALTAXID}</td>
                                                <td className="text-center">S/.{Number(pedido.DOCTOTAL).toFixed(2) || 0}</td>                                            
                                                <td className="text-center">{pedido.DOCDATE}</td>
                                                <td className="text-center" style={{whiteSpace:'nowrap'}}>{pedido.CREATEDATE}</td>
                                                <td className="text-center">{pedido.CREATETIME}</td>
                                                <td className="text-center">{pedido.DOCNUM}</td>
                                                <td className="text-center">{pedido.TIPO}</td>
                                                <td className="text-center">{pedido.TABLE}</td>
                                                <td className="text-center">{pedido.CURRENTSTATUS}</td>
                                            </tr>
                                        )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

}


const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegistroPedidosView);
